import React, { useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../features/auth/AuthContext';
import { useEffect } from 'react';
import api from '../../api/api';
import { proceedToPayData, resetProceedToPay } from '../../state/actions/coursePaymentAction';
import { createMeetingBooking } from '../../components/BookAMeeting/meetingService';
import './StripePayment.css'; // Make sure to create a CSS file for styles
import { resetRemoveCart } from '../../state/reducers/removeCartReducer';
import { cartList } from '../../state/actions/cartlistAction';
import { useNavigate } from "react-router";
import { toast } from 'react-toastify';

 



const RazorpayCheckout = ({ onClose, setloading = () => {}, purchaseType = "course", bookingData = null, orderId = null }) => {

    console.warn("RAZORPAY");
    const { token } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState('');
    const [paymentSuccessPopup, setpaymentSuccessPopup] = useState(false);
    const [isPaymentLoading, setisPaymentLoading] = useState(false);
    const removeCart = useSelector((state) => state.removeCartData);
    const proceedToPay = useSelector((state) => state.proceedToPay);
    const [paymentData, setPaymentData] = useState(null)
    const orderIdRef = useRef(null); // Store internal order_id immune to redux resets



    const proceedToPaybtn = () => {
        dispatch(proceedToPayData(token));
    };

    //     const loadScript = (src) => {
    //     return new Promise((resolve, reject) => {
    //         // ✅ Avoid loading the script twice if already present
    //         const existingScript = document.querySelector(`script[src="${src}"]`);
    //         if (existingScript) {
    //             resolve();
    //             return;
    //         }
    //         const s = document.createElement("script");
    //         s.src = src;
    //         s.onload = resolve;
    //         s.onerror = reject;
    //         document.body.appendChild(s);
    //     });
    // };




    const handleSubmit = async () => {
        setloading(true);

        // For meet_session use prop, for courses use Redux
        const effectiveOrderId = purchaseType === "meet_session"
          ? orderId
          : proceedToPay?.order_id;

        if (!effectiveOrderId) {
          toast.error("Order not found. Please go back and book again.");
          setloading(false);
          return;
        }

        try {
            const payload = {
                order_id: effectiveOrderId,
                purchase_type: purchaseType,
                payment_gateway: "razorpay",
            };
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            };
            const paymentIntentResponse = await api.post('payments/payment/', payload, config);
            setPaymentData(paymentIntentResponse.data);
            const clientSecret = paymentIntentResponse.data.client_secret

        } catch (err) {
            console.error(err);
            const msg = err?.response?.data?.message || "Could not initiate payment. Please try again.";
            toast.error(msg);
            setloading(false);
        }
    };

    const LoadScript =()=>{
         return new Promise((resolve) => {
        // Don't load if already loaded
        if (window.Razorpay) {
            resolve(true);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
    }

    const loadrazorpayScript = async () => {

    const scriptLoaded = await LoadScript();

    if (!scriptLoaded) {
        toast.error("Failed to load payment gateway. Please try again.");
        setloading(false);
        return;
    }

        if (paymentData != null) {
            let options = {
                key: paymentData?.key_id || "",
                amount: paymentData?.amount || 0,
                currency: paymentData?.currency || "INR",
                name: paymentData.name || "Proschool",
                notes: {
                    order_id: paymentData?.notes?.order_id,
                    purchase_type: paymentData?.notes?.purchase_type || "course",
                },
                order_id: paymentData?.order_id || "",

                handler: function (response) {
                    //console.log(" SUCCESS:", response);
                    verifyPayment(response);
                },
                modal: {
                    ondismiss: function () {
                        dispatch(resetProceedToPay());
                        if (onClose) onClose(); // unmount this modal
                        setloading(false);
                        // Redirect to TeacherProfileSettings when user closes popup
                        navigate(-1); // Go back to the previous page
                    }
                },
                payment_gateway: paymentData?.payment_gateway || "razorpay",
                prefill: {
                    email: paymentData?.prefill?.email || "",
                    name: paymentData?.prefill?.name || "",
                }
            }
            //console.warn("open",paymentData, options);
            const rzp = new window.Razorpay(options);
            rzp.open();
            rzp.on("payment.failed", function (response) {
                setError(true)
                setisPaymentLoading(false)
                console.log("Payment Failed:", response);
            });
        }
        else{
            console.error("Payment data is not available.");
            setloading(false)
        }


    }

    const verifyPayment = async (response) => {
        try {
            // Use order_id from ref (stable, immune to redux resets)
            // Fallback to proceedToPay only if ref is somehow empty
            const internalOrderId = orderIdRef.current ?? proceedToPay?.order_id;

            console.log("orderIdRef.current:", orderIdRef.current);
            console.log("proceedToPay?.order_id:", proceedToPay?.order_id);
            console.log("Using internalOrderId:", internalOrderId);

            // Guard: fail loudly instead of POSTing order_id: null
            if (!internalOrderId) {
                console.error("verifyPayment: missing internal order_id", {
                    paymentData,
                    proceedToPay,
                    orderIdRef: orderIdRef.current,
                });
                toast.error("Could not verify payment — order reference missing. Please contact support.");
                setError(true);
                setloading(false);
                return;
            }

            const payload = {
                razorpay_order_id: response?.razorpay_order_id,
                razorpay_payment_id: response?.razorpay_payment_id,
                razorpay_signature: response?.razorpay_signature,
                order_id: internalOrderId,
            };
            console.log("Verify Razorpay payload:", payload);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            };
            const verifyResponse = await api.post('/payments/verify-razorpay/', payload, config);
            console.log("Payment verification response:", verifyResponse.data);
            if (verifyResponse.data.status === 200) {
              //  console.warn("Razorpay success");

                // For meet_session: booking was already created BEFORE payment in coursePaymentAction
                // For course: booking is handled separately, not here
                // Just verify payment and navigate
                setPaymentStatus('Payment succeeded!');
                setisPaymentLoading(false);
                setpaymentSuccessPopup(true);

                // Only refresh cart for course purchases, not for meet_session bookings
                if (purchaseType !== "meet_session") {
                  dispatch(cartList(token));
                  dispatch(resetRemoveCart());
                }
                setloading(false)

                // Redirect based on purchase type
                const redirectUrl = purchaseType === "meet_session"
                  ? `/dashboard/meetings`
                  : `/dashboard/my-courses/active-courses`;
                navigate(redirectUrl);

            } else {
                setError(true);
                setloading(false)
            }
        } catch (err) {
            console.error("Payment verification failed:", err);
            setError(true);
            setloading(false)
        }
    }



    // For courses only: auto-submit when order_id is set by proceedToPayData
    useEffect(() => {
        if (proceedToPay.order_id != null && purchaseType !== "meet_session") {
            handleSubmit();
        }
    }, [proceedToPay.order_id, purchaseType]);


    useEffect(() => {
        if (paymentData != null) {
            // Capture internal order_id from paymentData (immune to redux resets)
            // paymentData.notes.order_id is the one we sent in handleSubmit
            orderIdRef.current = paymentData?.notes?.order_id ?? paymentData?.order_id ?? null;
            console.log("Captured order_id in ref:", orderIdRef.current);
            loadrazorpayScript();
        }

    }, [paymentData])

useEffect(() => {
    if (purchaseType === "meet_session") {
        // For meet_session: orderId comes from prop, trigger payment directly
        if (!orderId) {
          toast.error("Order not found. Please go back and book again.");
          onClose?.();
          return;
        }
        handleSubmit(); // Kick off payment with the prop orderId
    } else {
        // For courses: create order via Redux first
        dispatch(proceedToPayData(token, null, false, 0, purchaseType, null));
    }

    return () => {
        dispatch(resetProceedToPay()); // Clean up on unmount
    };
}, [purchaseType]);
 
useEffect(() => {
    // Only handle course purchase flow — meet_session already redirects in verifyPayment
    if (paymentSuccessPopup && purchaseType !== "meet_session") {
      setTimeout(() => {
        setpaymentSuccessPopup(false)
        dispatch(cartList(token));
        dispatch(resetRemoveCart());
        navigate(`/dashboard/my-courses/active-courses`);
      }, 5000)
}
    }, [paymentSuccessPopup, purchaseType, dispatch, token, navigate]);



    return (
        <>
            {/* <div>rpCheckout</div>
            <button onClick={proceedToPaybtn} >Pay</button> */}

            {/* PENDING POPUP */}
            {
                isPaymentLoading && <div>
                    <div className="pp-overlay">
                        <div className="pp-container">


                            {/* Icon */}
                            <div className="pp-icon" aria-hidden="true">
                                <div className="pp-doc">
                                    <span className="pp-line l1" />
                                    <span className="pp-line l2" />
                                    <span className="pp-line l3" />

                                    <span className="pp-check c1" />
                                    <span className="pp-check c2" />
                                </div>

                                <div className="pp-card">
                                    <span className="pp-card-strip" />
                                    <span className="pp-card-chip" />
                                </div>
                            </div>

                            <h2 className="pp-title">Please Wait</h2>

                            <p className="pp-sub">
                                Completing your transaction<span className="pp-dots" />
                            </p>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default RazorpayCheckout


//prlb i am facing: checkout data is missing "course name , price , etc "


//flow createorder-> payment/payment api -> razorpay api-> success/failure->varification -> compare id ->congratulations popup

//pending :  cartlist empty after success , error handling 
